import { render, staticRenderFns } from "./InputSimpleTextVertical.vue?vue&type=template&id=f48e9a9e&scoped=true"
import script from "./InputSimpleTextVertical.vue?vue&type=script&lang=js"
export * from "./InputSimpleTextVertical.vue?vue&type=script&lang=js"
import style0 from "./InputSimpleTextVertical.vue?vue&type=style&index=0&id=f48e9a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e9a9e",
  null
  
)

export default component.exports